import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { api } from '../services/api';
import type { UnreadCount } from 'shared/types/index.js';

interface NotificationState {
  unreadCount: UnreadCount;
  pendingApprovalCount: number;
  actionCount: number;
  fetchUnreadCount: () => Promise<void>;
}

export const useNotificationStore = create<NotificationState>()(
  devtools(
    (set, get) => ({
      unreadCount: { total: 0, urgent: 0, normal: 0, info: 0 },
      pendingApprovalCount: 0,
      actionCount: 0,

      fetchUnreadCount: async () => {
        try {
          const [countResult, approvalResult, actionsResult] = await Promise.all([
            api.getUnreadCount(),
            api.getPendingApprovals().catch(() => null),
            api.getMyActions().catch(() => null),
          ]);
          const updates: Partial<NotificationState> = {};
          if (countResult.success && countResult.data) {
            updates.unreadCount = countResult.data;
          }
          if (approvalResult?.success && approvalResult.data) {
            updates.pendingApprovalCount = approvalResult.data.length;
          }
          if (actionsResult?.success && actionsResult.data) {
            updates.actionCount = actionsResult.data.length;
          }
          if (Object.keys(updates).length > 0) {
            set(updates);
          }
        } catch {
          // ignore
        }
      },
    }),
    { name: 'NotificationStore' }
  )
);
